import { Component } from "react";
import toast from "react-hot-toast";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import ToggleSwitch from "../../components/toggleSwitch";
import withRouter from "../../components/withRouter/withRouter";

class AddUpdateAboutHero extends Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    title: "",
    content: "",
    loading: false,
    _id: "",
    heroData: [],
  };

  componentDidMount = () => {
    this.getData();
  };

  getData = () => {};

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
    });
  };

  uploadImage = async () => {
    // if (this.state.imageObject) {
    //   try {
    //     const response = await uploadImageApi(
    //       this.state.imageObject,
    //       "technology"
    //     );
    //     return response.data.imageUrl;
    //   } catch (error) {
    //     console.log(error);
    //     throw error;
    //   }
    // }
    // return this.state.imageUrl;
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.subHeading) {
      toast.error("Sub Heading is required.");
      return false;
    }

    if (this.state.buttonShow && !this.state.btnText) {
      toast.error("Button text is required.");
      return false;
    }
    if (this.state.buttonShow && !this.state.btnUrl) {
      toast.error("Button Url is required.");
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    if (this.validate()) {
      //   console.log("inside handle submit");
      //   this.setState({ loading: true });
      //   this.uploadImage()
      //     .then((r) => {
      //       console.log("uploaded image", r);
      //       const data = {
      //         image: r,
      //         imageCaption: this.state.imageCaption,
      //         imageAlt: this.state.imageAlt,
      //         title: this.state.title,
      //         subHeading: this.state.subHeading,
      //         buttonText: this.state.btnText,
      //         buttonUrl: this.state.btnUrl,
      //         buttonShow: this.state.buttonShow,
      //       };
      //       console.log(data);
      //       if (this.props.router.params?.id) {
      //         const hero = this.state.heroData.map((val) => {
      //           if (val._id === this.props.router.params?.id) {
      //             return {
      //               ...data,
      //               _id: this.props.router.params?.id,
      //             };
      //           } else return val;
      //         });
      //         updateStaffAugmentation({ hero }, this.state._id)
      //           .then((res) => {
      //             toast.success("Updated successfully.");
      //             this.setState({ loading: false });
      //             this.props.router.navigate("/staff-augmentation");
      //           })
      //           .catch((err) => {
      //             console.log("Error: ", err);
      //             toast.error("Something went wrong");
      //             this.setState({ loading: false });
      //           });
      //       } else {
      //         const hero = [
      //           ...this.state.heroData,
      //           {
      //             ...data,
      //           },
      //         ];
      //         updateStaffAugmentation({ hero }, this.state._id)
      //           .then((res) => {
      //             toast.success("Updated successfully.");
      //             this.setState({ loading: false });
      //             this.props.router.navigate("/staff-augmentation");
      //           })
      //           .catch((err) => {
      //             console.log("Error: ", err);
      //             toast.error("Something went wrong");
      //             this.setState({ loading: false });
      //           });
      //       }
      //     })
      //     .catch((er) => {
      //       toast.error("Error While uploading image.");
      //       this.setState({ loading: false });
      //     });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title="Add Hero Carousel For Career"
            showBtn1={true}
            btn1Text="Save"
            btn1Name="btn1"
            btn1type="filled"
            showBtn2={true}
            btn2Text="Cancel"
            btn2Name="btn2"
            btn2type="outlined_del"
            onClickHandler={(e) => {
              console.log(e);
              if (e.target.name === "btn1") {
                this.handleSubmit();
              } else this.props.router.navigate("/about");
            }}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                      marginBottom: "10px",
                    }}
                  >
                    Image
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "45%",
                        aspectRatio: "16/9",
                        backgroundImage: `url('${
                          this.props.router.params.id
                            ? this.state.isImageChanged
                              ? this.state.imageUrl
                              : this.state.imageUrl
                            : this.state.imageUrl
                        }')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginBottom: "40px",
                        marginTop: "10px",
                        borderRadius: "15px",
                        position: "relative",
                      }}
                    ></div>
                  )}
                </div>
                {this.state.imageUrl && (
                  <div className="grid_2">
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Caption"}
                      value={this.state.imageCaption}
                      onChange={(e) => {
                        this.setState({ imageCaption: e.target.value });
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Alt"}
                      value={this.state.imageAlt}
                      onChange={(e) =>
                        this.setState({ imageAlt: e.target.value })
                      }
                    />
                  </div>
                )}
                <div className="grid">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={this.state.title}
                    onChange={(e) => {
                      this.setState({ title: e.target.value });
                    }}
                  />
                  <InputField
                    type="textarea"
                    isLabel={true}
                    lable={"Content"}
                    value={this.state.content}
                    onChange={(e) => this.setState({ content: e.target.value })}
                  />
                </div>
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateAboutHero);
